export default "__VITE_ASSET__9a9520ad__"